export class MetaDataModel {
  workOrderNo: string = '';
  workingDate: Date | null = null;
  worksite: string = '';
  toCustomerAddress: string = '';
  quotationTc: string = '';
  businessName: string = '';

  constructor(init?: Partial<MetaDataModel>) {
    Object.assign(this, init);
  }
}